import { Helmet } from 'react-helmet-async';
import inbanner from '../../assets/img/abtwfr.jpg';
import InnerBanner from './InnerBanner';
const About = () => {
    return (
        <>
            <div className="page page_home">
                <Helmet>
                    <title>About US</title>
                    <meta name='description' content='First Source is a talent acquisition partner designed for today’s business landscape. We’re here to simplify hiring by focusing on what matters most – candidates who fit perfectly, from the start. Through our commitment to zero rejections at L1, we cut down on mismatches, saving you time and giving you the best talent, right away' />
                    <meta name="keywords"
                        content="FirstResource, firstresource, first resource, recruitment, recruiters, talent acquisition, hiring, staffing, job placement, workforce solutions, recruitment agency, employment services, candidate sourcing, recruitment solutions, talent management, HR services, recruitment consultancy" />
                </Helmet>
                <InnerBanner />
                <div className="section inpurpose">
                    <div className="container inpurposein px-4 px-lg-5 mb-2 mb-lg-5">
                        <h2 className="display-2 fwbold mb-3 mb-lg-5">Our Purpose</h2>
                        <div className="ps-1 ps-lg-5">
                            <p className="fs-3 fw-medium ps-0 ps-lg-5 ms-0 ms-lg-5">
                                First Source is a talent acquisition partner designed for today’s business landscape. We’re here to simplify hiring by focusing on what matters most – candidates who fit perfectly, from the start. Through our commitment to zero rejections at L1, we cut down on mismatches, saving you time and giving you the best talent, right away
                            </p>
                        </div>
                    </div>
                </div>
                <div className="section inwhy bg-body-secondary">
                    <div className="backstage">
                        <div className="cover">
                            <img src={inbanner} alt="employee" />
                        </div>
                    </div>
                    <div className="container inwhyin px-4 px-lg-5 py-5">
                        <div className="inwhy_content">
                            <div className="title">
                                <h2 className="display-2 fw-bold mb-3 mb-lg-5"><span className='text-light d-block d-lg-inline'>Why</span> <span className='text-secondary  d-block d-lg-inline'>First Resource?</span></h2>
                            </div>
                            <div className="ps-1 ps-lg-5">
                                <p className="fs-3 fwmed text-body-secondary  ms-0 ms-lg-5">
                                    Zero Rejections: Every resume that crosses your desk is high-quality and ready to add value.

                                </p>
                                <p className="fs-3 fwmed text-body-secondary  ms-0 ms-lg-5">
                                    Industry Insight: Our experts understand the specific challenges of your business and bring experience and insight to our your hiring efforts.
                                </p>
                                <p className="fs-3 fwmed text-body-secondary  ms-0 ms-lg-5">
                                    Client-Centric Focus: We prioritize clear communication and deep understanding, ensuring we’re always aligned with your goals.

                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section inppi">
                    <div className="container">
                        <div className="titles fwbold text-dark text-opacity-25">
                            Precision
                        </div>
                        <div className="titles fwbold text-body-tertiary text-center">
                            Partnership
                        </div>
                        <div className="titles fwbold text-body-tertiary text-end">
                            Impact
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default About;